import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedtext'
})
export class LocalizedTextPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(items: [{}], field?: string): string {
    field = field || 'text';

    let lang = this.translate.currentLang;
    let defaultLang = this.translate.defaultLang;

    let localizedItem = null;

    if (!!items) {
      localizedItem = items.find(i => i['lang'] === lang);
      if (!localizedItem || this.isBlank(localizedItem[field])) {
        localizedItem = items.find(i => i['lang'] === defaultLang);
      }
    }
    return !!localizedItem ? localizedItem[field] : '';
  }

  private isBlank(text: string) {
    return !text || !text.replace(/^\s+|\s+$/, '');
  }

}
